import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "./deepagent-matrix.js";

import type { MatrixMode } from "./deepagent-matrix.js";

/** The agent's face: the owner's picture, or the agent matrix when there is none or it fails. */
@customElement("deepagent-avatar")
export class DeepAgentAvatar extends LitElement {
  static override styles = css`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: var(--da-avatar-size, 32px);
      height: var(--da-avatar-size, 32px);
      flex: 0 0 auto;
    }
    /* Only the photo takes the owner's corners: the matrix keeps its square cells. */
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      border-radius: var(--da-radius, 2px);
    }
    deepagent-matrix {
      --da-matrix-size: 100%;
      --da-matrix-gap: max(1px, calc(var(--da-avatar-size, 32px) * 0.06));
    }
    :host([data-cells="9"]) deepagent-matrix {
      --da-matrix-gap: max(2px, calc(var(--da-avatar-size, 32px) * 0.025));
    }
  `;

  @property({ type: String }) url: string | null = null;
  @property({ type: String }) mode: MatrixMode = "idle";
  /** Cells per side of the fallback matrix: 3 for a small face, 9 for a large one. */
  @property({ type: Number, reflect: true, attribute: "data-cells" }) cells = 3;
  @state() private failedUrl: string | null = null;

  override render() {
    const url = this.url;
    return url && url !== this.failedUrl
      ? html`<img src=${url} alt="" @error=${() => { this.failedUrl = url; }} />`
      : html`<deepagent-matrix .mode=${this.mode} .cells=${this.cells}></deepagent-matrix>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { "deepagent-avatar": DeepAgentAvatar; }
}
